import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import InformationCircle from '@/components/icons/InformationCircle';
import { FC, useState } from 'react';
import EButton from '@/components/everridge/EButton';

type Props = {
    content: string;
};

const ETooltip: FC<Props> = ({ content }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <TooltipProvider>
            <Tooltip open={isOpen}>
                <TooltipTrigger asChild>
                    <EButton
                        variant="ghost"
                        size="link"
                        onClick={() => setIsOpen((prev) => !prev)}
                        onMouseEnter={() => setIsOpen(true)}
                        onMouseLeave={() => setIsOpen(false)}
                        onTouchStart={() => setIsOpen(true)}
                        onKeyDown={(e) => {
                            e.preventDefault();
                            if (e.key === 'Enter') setIsOpen((prev) => !prev);
                        }}
                    >
                        <InformationCircle className="cursor-pointer" />
                    </EButton>
                </TooltipTrigger>
                <TooltipContent className="max-w-50">{content}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default ETooltip;
